import React, { useEffect, useRef, useState, useContext, useCallback } from 'react';
import L from 'leaflet';
import Chart from 'chart.js/auto';
import zoomPlugin from 'chartjs-plugin-zoom';
import annotationPlugin from 'chartjs-plugin-annotation';
import 'leaflet/dist/leaflet.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faEllipsisV, faTimes, faVideoCamer,faDatabase, faExpand, faMinimize } from "@fortawesome/free-solid-svg-icons";
import UnifiedVideoPlayer from "./UnifiedVideoPlayer";
import { useVideoSync } from "./VideoSyncManager";
import SegmentCreator from "./SegmentCreator";
import { MapContext } from "./MapProvider";
import { auth } from "../firebase"; // Use the same auth instance as in Header.js
import { storage } from "../firebase"; // Ensure Firebase Storage is properly initialized
import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
import { getFirestore, doc, setDoc, updateDoc, getDoc } from "firebase/firestore";
import { Timestamp } from "firebase/firestore";
import creditCosts from "../config/creditCosts";
import Tooltip from './Tooltip';
import FitParser from 'fit-file-parser';
import { text } from '@fortawesome/fontawesome-svg-core';
import { FFmpeg } from '@ffmpeg/ffmpeg';
import { getFunctions, httpsCallable } from "firebase/functions";
import ModalPopup from './ModalPopup';

const db = getFirestore();


Chart.register(zoomPlugin, annotationPlugin);
function getFormattedRunName() {
  const now = new Date();
  const mm = String(now.getMonth() + 1).padStart(2, "0");
  const dd = String(now.getDate()).padStart(2, "0");
  const yy = String(now.getFullYear()).slice(-2);
  const hh = String(now.getHours()).padStart(2, "0");
  const min = String(now.getMinutes()).padStart(2, "0");
  const sec = String(now.getSeconds()).padStart(2, "0");
  return `run_${mm}-${dd}-${yy}_${hh}-${min}-${sec}`;
}
const Dashboard = ({
  dashboardId,
  randomColor,
  // NEW props from parent:
  masterSegments,
  onSegmentsChange,
  isMaster,
    runData = null,
    onMasterVideoRefReady = () => {},
    onMasterTelemetry = () => {},
    onChildTelemetry = () => {}, 
    onMasterTimeChange = () => {}, 
    videosLinked,       // new prop
}) => {
  const videoSync = useVideoSync();
  const [runName, setRunName] = useState(getFormattedRunName());
  const [credits, setCredits] = useState(0);
  const [telemetryData, setTelemetryData] = useState([]);
  const [videoSyncOffset, setVideoSyncOffset] = useState(0);
  const [currentVideoTime, setCurrentVideoTime] = useState(0);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const defaultRunData = {
    youtubeUrl: null,
    uploadedToYouTube: false,
    videoFileName: null,
    telemetryData: [],
    metrics: {},
  };
  const user = auth.currentUser;
  const userId = user ? user.uid : null; // ✅ Get the authenticated user's Firestore UID
  const CHUNK_SIZE = 10 * 1024 * 1024; // 10MB chunks
 const [myColor] = useState(randomColor);
 const [youtubeUrl, setYoutubeUrl] = useState('');
 const combinedChartRef = useRef(null);
 const [selectedVideoFile, setSelectedVideoFile] = useState(null);
 const { mapRef } = useContext(MapContext);
 const dashboardLayers = useRef(null);
 const colorLibrary = [
   "#D62728","#1F77B4","#2CA02C","#9467BD","#8C564B","#E377C2","#7F7F7F",
   "#BCBD22","#17BECF","#FF7F0E","#C49C94","#393B79","#637939","#8C6D31",
   "#843C39","#A55194","#6B6ECF","#B5CF6B","#E6550D","#3182BD"
 ];
 const [currentSpeed, setCurrentSpeed] = useState(0);
 const [frontBrake, setFrontBrake] = useState(0);
 const [rearBrake, setRearBrake] = useState(0);
 const [combinedBrake, setCombinedBrake] = useState(0);

 const [uploadToYouTube, setUploadToYouTube] = useState(false); // New: Checkbox state
 const [isProcessing, setIsProcessing] = useState(false);
 const [message, setMessage] = useState("");
 const [uploadProgress, setUploadProgress] = useState(0);
 const [modalState, setModalState] = useState({ isOpen: false, status: 'loading' });
 const [exportModalState, setExportModalState] = useState({
  isOpen: false,
  phase: 'start' // 'start' | 'progress' | 'done'
});
 const [progress, setProgress] = useState(0);
 const [youtubeDirectUrl, setYoutubeDirectUrl] = useState(null);
 const CLIENT_ID = "493819678818-jpeodeohno8dq190calvns8010c3ieue.apps.googleusercontent.com";
 const CLIENT_SECRET = "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";
 const REFRESH_TOKEN = "1//04VqpgfqO57y4CgYIARAAGAQSNwF-L9Irv7fpvE_AcByYDDz82zB5EEMSFG9G5QpclEaRS6-1dN-GgqIsPHQL6eBAeK-cHBq-KB4"
 const [menuOpen, setMenuOpen] = useState(false);
 const [isFullscreen, setIsFullscreen] = useState(false);
 const fullScreenContainerRef = useRef(null);
 const currentRunData = runData || null;
 const [loadedRun, setLoadedRun] = useState(null);
 const [localYoutubeUrl, setLocalYoutubeUrl] = useState(null);
 const [activeTab, setActiveTab] = useState("graph");
 const gpmdCancelRef = useRef(false);


  useEffect(() => {
    // Only update loadedRun if runData is truthy (i.e. a run has been loaded)
    if (runData) {
      setLoadedRun(runData);
    }
  }, [runData]);


  
  useEffect(() => {
    return () => {
      // Cleanup path & marker when this Dashboard unmounts
      if (dashboardLayers.current && mapRef?.current) {
        mapRef.current.removeLayer(dashboardLayers.current.layer);
        dashboardLayers.current = null;
      }
    };
  }, []);
  


  useEffect(() => {
    console.log("11");
    if (isMaster && telemetryData.length > 0) {
      onMasterTelemetry(telemetryData);
    }
  }, [isMaster, telemetryData, onMasterTelemetry]);

  useEffect(() => {
    console.log("12");
    console.log("Telemetry Data:", telemetryData);
  }, [telemetryData]);


useEffect(() => {
  console.log("14");
  const currentRunData = runData || defaultRunData;

  // Load telemetry data if available
  setTelemetryData(currentRunData.telemetryData || []);

   // Restore offset if it exists
 if (typeof currentRunData.videoSyncOffset === 'number') {
   setVideoSyncOffset(currentRunData.videoSyncOffset);
 }

  // Load metrics from Firestore entry
  if (currentRunData.metrics) {
    const metrics = currentRunData.metrics;
    const setMetricValue = (id, value) => {
      const elementId = `${id}-${dashboardId}`;
      const el = document.getElementById(elementId);
      if (el) {
        el.textContent = value || "N/A";
      } else {
        console.warn(`updateMetrics: Element with id ${elementId} not found.`);
      }
    };

    setMetricValue("total-distance", metrics.totalDistance);
    setMetricValue("total-elevation-loss", metrics.elevationLoss);
    setMetricValue("total-time-braking-front", metrics.brakingFront);
    setMetricValue("total-time-braking-rear", metrics.brakingRear);
    setMetricValue("total-time-braking", metrics.totalBraking);
    setMetricValue("proportion-power", metrics.proportionPower);
  }

  // ✅ Prompt to load a local video if no YouTube video exists
  if (!currentRunData.uploadedToYouTube && currentRunData.videoFileName) {
    setTimeout(() => {
      const userResponse = window.confirm(
        `This run was saved with a local video file: "${currentRunData.videoFileName}". Would you like to select this file now?`
      );

      if (userResponse) {
        document.getElementById(`file-input-${dashboardId}`).click();
      }
    }, 1000); // Delay to ensure UI is ready
  }
}, [runData, dashboardId]);
// useEffect(() => {
//   // if telemetryData is non-empty, tell the parent
//   onChildTelemetry(telemetryData);
// }, [telemetryData, onChildTelemetry]);

  useEffect(() => {
    console.log("15");
    if (runData?.uploadedToYouTube && runData.youtubeUrl) {
      const videoId = extractYouTubeVideoID(runData.youtubeUrl);
  
      if (videoId) {
        fetchYouTubeDirectUrl(videoId).then((url) => {
          if (url) {
            setYoutubeDirectUrl(url);
          } else {
            console.warn("⚠️ Could not fetch YouTube direct URL.");
          }
        });
      }
    }
  }, [runData]);

  const handleFullscreenToggle = () => {
    if (!document.fullscreenElement) {
      // Request fullscreen on our container
      fullScreenContainerRef.current
        .requestFullscreen()
        .then(() => {
          setIsFullscreen(true);
        })
        .catch((err) => console.error("Failed to enter fullscreen:", err));
    } else {
      document.exitFullscreen().then(() => {
        setIsFullscreen(false);
      });
    }
  };

  function getCurrentUserId() {
    const user = auth.currentUser;
    return user ? user.email : null; // Return email instead of UID
  }

  const getCurrentUserEmail = () => {
    return auth.currentUser ? auth.currentUser.email : null;
  };
  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

const formatDate = (date) => {
  return date.toLocaleString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).replace(',', ''); // Removes unnecessary comma
};

const formatDateForPlaceholder = () => {
  const now = new Date();
  const mm = String(now.getMonth() + 1).padStart(2, "0");
  const dd = String(now.getDate()).padStart(2, "0");
  const yyyy = now.getFullYear();
  return `${mm}-${dd}-${yyyy}`;
};

const placeholderName = `run_${dashboardId}_${formatDateForPlaceholder()}`;

async function getAccessToken() {
    try {
        const response = await fetch("https://oauth2.googleapis.com/token", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: new URLSearchParams({
                client_id: CLIENT_ID,
                client_secret: CLIENT_SECRET,
                refresh_token: REFRESH_TOKEN,
                grant_type: "refresh_token",
            }),
        });

        const data = await response.json();
        if (data.access_token) {
            return data.access_token;
        } else {
            throw new Error(`Failed to get access token: ${JSON.stringify(data)}`);
        }
    } catch (error) {
        console.error("❌ Error getting access token:", error);
        return null;
    }
}
const hasVideo = !!(selectedVideoFile || runData.youtubeUrl);
const hasData = telemetryData.length > 0;

const handleSaveRun = async () => {
  setIsProcessing(true);
  setMessage("⏳ Saving run data...");

  const userEmail = getCurrentUserEmail();
  if (!userEmail) {
    setMessage("❌ User not authenticated. Please log in.");
    setIsProcessing(false);
    return;
  }

  const userId = auth.currentUser ? auth.currentUser.uid : null;
  if (!userId) {
    setMessage("❌ User ID not found.");
    setIsProcessing(false);
    return;
  }

  // Generate or reuse a runId
  const existingRunId = (loadedRun?.runId || loadedRun?.id) || (runData?.runId || runData?.id);
  let runId = existingRunId ? existingRunId : `${userEmail}_${Date.now()}`;

  console.log("handleSaveRun: computed runId =", runId);

  if (!selectedVideoFile && !runData?.youtubeUrl && telemetryData.length === 0) {
    setMessage("❌ No data available. Please load telemetry before saving.");
    setIsProcessing(false);
    return;
  }

  let reducedTelemetryData = telemetryData;
  if (JSON.stringify(telemetryData).length > 900000) {
    console.warn("📉 Telemetry data too large. Downsampling...");
    const step = Math.ceil(telemetryData.length / 5000);
    reducedTelemetryData = telemetryData.filter((_, index) => index % step === 0);
    console.log(`✅ Telemetry reduced from ${telemetryData.length} → ${reducedTelemetryData.length} points`);
  }

  const runDataToSave = {
    runName: runName || runData?.runName || `Run_${new Date().toISOString()}`,
    userId,
    videoFileName: selectedVideoFile ? selectedVideoFile.name : runData?.videoFileName || null,
    csvFileName: telemetryData.length > 0 ? "telemetry.csv" : null,
    telemetryData: reducedTelemetryData || [],
    youtubeUrl: runData?.youtubeUrl || null,
    uploadedToYouTube: runData?.uploadedToYouTube || false,
    timestamp: new Date(),
    videoSyncOffset,
    runId,
    ownerId: userId,
    uploadToYouTube,
  };

  try {
    const runRef = doc(db, "runs", runId);
    const docSnap = await getDoc(runRef);

    if (docSnap.exists()) {
      await updateDoc(runRef, runDataToSave);
      setMessage("✅ Run updated successfully!");
    } else {
      await setDoc(runRef, runDataToSave);
      setMessage("✅ Run saved successfully!");
    }

    setLoadedRun(runDataToSave);

    // ✅ Pass runId to YouTube Upload
    if (uploadToYouTube && selectedVideoFile) {
      console.log("📤 Uploading video to YouTube...");
      await handleUploadToYouTube(selectedVideoFile, runId);
    }
  } catch (error) {
    console.error("❌ Error saving run:", error);
    setMessage(`Error: ${error.message}`);
  } finally {
    setIsProcessing(false);
  }
};

const handleUploadToYouTube = async (file, runId) => {
  if (!runId) {
    console.error("❌ handleUploadToYouTube: No runId provided. Aborting upload.");
    setMessage("❌ Error: No run ID for YouTube upload.");
    return;
  }
  setMessage("📤 Uploading to YouTube...");
  setUploadProgress(0);

  const token = await getAccessToken();
  if (!token) {
    console.error("❌ Error: No YouTube access token.");
    setMessage("❌ YouTube authentication failed.");
    return;
  }

  const metadata = {
    snippet: {
      title: runName || "New Run",
      description: "Uploaded from Victorise.",
      tags: ["cycling", "telemetry"],
      categoryId: "22",
    },
    status: { privacyStatus: "unlisted" },
  };

  // Step 1: Initiate the resumable upload session
  const initiateResumableUpload = async () => {
    const response = await fetch(
      "https://www.googleapis.com/upload/youtube/v3/videos?uploadType=resumable&part=snippet,status",
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json; charset=UTF-8",
          "X-Upload-Content-Length": file.size,
          "X-Upload-Content-Type": file.type,
        },
        body: JSON.stringify(metadata),
      }
    );

    if (!response.ok) {
      throw new Error("❌ Failed to initiate resumable upload");
    }

    return response.headers.get("location"); // The upload URL
  };

  try {
    let uploadUrl = await initiateResumableUpload();
    let offset = 0;
    const chunkSize = 10 * 1024 * 1024; // 10MB

    // Step 2: Resume from where we left off (if applicable)
    const getUploadStatus = async () => {
      const statusResponse = await fetch(uploadUrl, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Range": `bytes */${file.size}`, // Ask where to resume
        },
      });

      if (statusResponse.status === 308) {
        const rangeHeader = statusResponse.headers.get("Range");
        if (rangeHeader) {
          const rangeMatch = rangeHeader.match(/bytes=(\d+)-(\d+)/);
          if (rangeMatch) {
            offset = parseInt(rangeMatch[2]) + 1;
            console.log(`📌 Resuming upload from byte ${offset}`);
          }
        }
      }
    };

    await getUploadStatus(); // Check if we need to resume

    // Step 3: Upload chunks
    while (offset < file.size) {
      const chunk = file.slice(offset, offset + chunkSize);
      const isLastChunk = offset + chunk.size >= file.size;

      const response = await fetch(uploadUrl, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Length": chunk.size,
          "Content-Range": `bytes ${offset}-${offset + chunk.size - 1}/${file.size}`,
        },
        body: chunk,
      });

      if (!response.ok && response.status !== 308) {
        throw new Error(`❌ Chunk upload failed: ${await response.text()}`);
      }

      offset += chunk.size;
      const progress = Math.round((offset / file.size) * 100);
      setUploadProgress(progress);
      setMessage(`📤 Uploading to YouTube (it might take some time with a large file)... ${progress}%`);

      // If YouTube responds with 308 (Resume Incomplete), continue uploading
      if (response.status === 308) {
        console.log(`⏳ Chunk uploaded (${progress}%), resuming...`);
      } else if (response.status === 200) {
        const result = await response.json();
        if (result.id) {
          const youtubeUrl = `https://www.youtube.com/watch?v=${result.id}`;
          console.log("✅ Video fully uploaded! YouTube URL:", youtubeUrl);
          setMessage("✅ Video uploaded successfully!");
          setYoutubeUrl(youtubeUrl);

          // ✅ Update Firestore with YouTube URL
          await updateFirestoreWithYouTubeUrl(runId, youtubeUrl);

          return;
        }
      }
    }
  } catch (error) {
    console.error("❌ Chunked YouTube upload failed:", error);
    setMessage("❌ YouTube upload failed.");
  }
};

const updateFirestoreWithYouTubeUrl = async (runId, youtubeUrl) => {
  if (!runId) {
    console.error("❌ Error: No runId provided. Firestore update skipped.");
    return;
  }

  try {
    const runRef = doc(db, "runs", runId);
    await updateDoc(runRef, {
      youtubeUrl: youtubeUrl,
      uploadedToYouTube: true, // ✅ Mark run as having a YouTube video
    });

    console.log("✅ Firestore updated with YouTube URL:", youtubeUrl);
  } catch (error) {
    console.error("❌ Error updating Firestore:", error);
  }
};
const handleSyncData = () => {
  console.log("🔧 Syncing Data...");
  
  // Use the current video time from the new video system
  if (currentVideoTime > 0) {
    setVideoSyncOffset(currentVideoTime);
    console.log(`🔧 Syncing Data: Video time = ${currentVideoTime}s is now telemetry time=0`);
    updateDashboardMarker(0);
    updateGraphAnnotation(0);
    return;
  }

  console.warn("⚠️ No video is currently playing to sync.");
};

const handleDataMixer = () => {

}


const handleExtractGPMD = async (file = selectedVideoFile) => {
  gpmdCancelRef.current = false;
  if (!file) {
    setMessage("❌ No video selected. Please upload a GoPro video first.");
    return;
  }

  let isCancelled = false;
  setIsProcessing(true);
  setModalState({ isOpen: true, status: 'loading' });
  setMessage("⏳ Extracting GPMD telemetry streams 2 and 3 from video...");

  // Progress tracking
  const startTime = Date.now();
  const fileSizeMB = (file.size / 1024 / 1024).toFixed(1);
  let currentStep = 0;
  const totalSteps = 8; // Total number of processing steps

  const updateProgress = (step, message, progress = null) => {
    currentStep = step;
    const elapsed = ((Date.now() - startTime) / 1000).toFixed(1);
    const estimatedTotal = Math.max(5, fileSizeMB * 2); // Estimate 2 seconds per MB
    const remaining = Math.max(0, estimatedTotal - elapsed);
    
    if (progress !== null) {
      setProgress(progress);
    } else {
      setProgress((step / totalSteps) * 100);
    }
    
    setMessage(`${message} (${elapsed}s elapsed, ~${remaining.toFixed(1)}s remaining)`);
  };

  // Use FileReader to get ArrayBuffer from the File
  const reader = new FileReader();
  reader.onload = async function () {
    try {
      const arrayBuffer = reader.result;
      updateProgress(1, "📁 Video file loaded", 10);
      
      // Import the GoPro extraction utility
      const { extractGoProGPS, validateGPSData, getGoProModelInfo } = await import('../utils/goproExtractor');

      // Get GoPro model information
      updateProgress(2, "🔍 Detecting GoPro model...", 20);
      const modelInfo = await getGoProModelInfo(arrayBuffer);
      console.log("📱 GoPro model info:", modelInfo);

      // Extract GPS data with multiple fallback methods
      updateProgress(3, "⏳ Extracting GPS data...", 30);
      const extractionResult = await extractGoProGPS(arrayBuffer, {
        requireGpsFix: false,
        debug: true,
        maxRetries: 3
      }, (progress, message) => {
        // Update progress with more granular feedback
        const adjustedProgress = 30 + (progress * 0.3); // Scale 0-100 to 30-60
        updateProgress(3, `⏳ ${message}`, adjustedProgress);
      });

      if (extractionResult.success) {
        if (gpmdCancelRef.current) return;
        
        updateProgress(4, "✅ GPS data extracted successfully", 60);
        console.log("✅ GPS data extracted successfully using:", extractionResult.method);
        console.log("📊 Samples found:", extractionResult.samples);
        console.log("📄 CSV Preview:", extractionResult.data.slice(0, 300));

        // Validate the extracted data
        updateProgress(5, "🔍 Validating GPS data quality...", 75);
        const validation = validateGPSData(extractionResult.data);
        console.log("🔍 GPS data validation:", validation);

        if (validation.valid) {
          updateProgress(6, "📊 Processing telemetry data...", 90);
          const parsedTelemetry = parseCSV(extractionResult.data);
          setTelemetryData(parsedTelemetry);
          
          updateProgress(7, "✅ Data loaded successfully!", 100);
          setMessage(`✅ GPS data extracted and loaded! (${extractionResult.method}) - ${validation.stats.validPoints} points, ${validation.stats.totalDistance}m total distance`);
          setModalState({ isOpen: true, status: 'data-found' });
        } else {
          updateProgress(7, "⚠️ Data quality issues detected", 100);
          console.warn("⚠️ GPS data validation failed:", validation.issues);
          setMessage(`⚠️ GPS data extracted but quality issues detected: ${validation.issues.join(', ')}`);
          setModalState({ isOpen: true, status: 'no-data' });
        }
      } else {
        if (gpmdCancelRef.current) return;
        updateProgress(7, "❌ GPS extraction failed", 100);
        console.warn("⚠️ GPS extraction failed:", extractionResult.error);
        setMessage(`❌ Failed to extract GPS data: ${extractionResult.error}`);
        setModalState({ isOpen: true, status: 'no-data' });
      }
    } catch (error) {
      if (gpmdCancelRef.current) return;
      updateProgress(7, "❌ Processing error occurred", 100);
      console.error("❌ Error processing video:", error);
      setMessage("❌ Failed to extract GPS data. Please try a different video or check if GPS was enabled during recording.");
      setModalState({ isOpen: true, status: 'no-data' });
    } finally {
      setIsProcessing(false);
    }
  };
  
  reader.onerror = function (e) {
    console.error("❌ FileReader error:", e);
    setIsProcessing(false);
    setMessage("❌ Failed to read file for GPS extraction.");
  };
  reader.readAsArrayBuffer(file);

  // Handler for cancellation (used in ModalPopup below)
  handleExtractGPMD.isCancelled = () => { isCancelled = true; };
};

// Export Overlay Video Function (Per-frame Graph Overlay)
const handleExportOverlay = async () => {
  console.log("📤 Exporting overlay video...");
  if (!selectedVideoFile || telemetryData.length === 0) {
    console.warn("⚠️ No video or telemetry data available for export.");
    return;
  }

  setIsProcessing(true);
  setProgress(0);
  setMessage("");
  setMessage("⏳ Preparing export...");
  setExportModalState({ isOpen: true, phase: 'progress' });

  try {
    const ffmpeg = new FFmpeg();
    await ffmpeg.load();
    console.log("✅ FFmpeg initialized");

    const fileArrayBuffer = await selectedVideoFile.arrayBuffer();
    const fileData = new Uint8Array(fileArrayBuffer);
    await ffmpeg.writeFile('input.mp4', fileData);
    console.log("✅ Input video written");

    // Write watermark image
    const watermarkImage = await fetch('/watermark.png');
    const watermarkBuffer = await watermarkImage.arrayBuffer();
    await ffmpeg.writeFile('watermark.png', new Uint8Array(watermarkBuffer));
    console.log("✅ Watermark written");

    // Generate chart images per frame
    const fps = 24;
    let duration = 10;
    try {
      const tempVideo = document.createElement('video');
      tempVideo.src = URL.createObjectURL(selectedVideoFile);
      await new Promise((resolve) => {
        tempVideo.onloadedmetadata = () => {
          duration = tempVideo.duration || 10;
          URL.revokeObjectURL(tempVideo.src);
          resolve();
        };
        setTimeout(() => resolve(), 2000);
      });
    } catch (e) {
      duration = 10;
    }
    const frameCount = Math.floor(duration * fps);

    const canvas = document.getElementById(`combinedGraph-${dashboardId}`);
    const ctx = canvas.getContext('2d');

    // Prepare a separate offscreen canvas for text rendering (make it large and visible)
    const textCanvas = document.createElement('canvas');
    textCanvas.width = 960;
    textCanvas.height = 540;
    const textCtx = textCanvas.getContext('2d');

    for (let i = 0; i < frameCount; i++) {
      const t = i / fps;
      updateGraphAnnotation(t);
      // ---- Draw speed overlay after annotation is updated, before export ----
      const telemetryPoint = getTelemetryPointForTimestamp(t, telemetryData);
      const speedText = telemetryPoint && telemetryPoint.speed !== undefined
        ? `Speed: ${telemetryPoint.speed.toFixed(1)} km/h`
        : "Speed: N/A";

      // Compose chart and speed overlay into a merged canvas (final video dimensions: 960x540)
      const mergedCanvas = document.createElement('canvas');
      mergedCanvas.width = 960;
      mergedCanvas.height = 540;
      const mergedCtx = mergedCanvas.getContext('2d');

      // Clear background
      mergedCtx.clearRect(0, 0, mergedCanvas.width, mergedCanvas.height);

      // Draw chart full width at bottom third of video
      const chartY = mergedCanvas.height * 2 / 3;
      const chartHeight = mergedCanvas.height / 3;
      mergedCtx.drawImage(canvas, 0, chartY, mergedCanvas.width/3*2, chartHeight);

      // Draw speed text in the top right of full video frame
      mergedCtx.font = "bold 24px Arial";
      mergedCtx.fillStyle = "#ffffff";
      mergedCtx.strokeStyle = "#000000";
      mergedCtx.lineWidth = 3;
      mergedCtx.textAlign = "right";
      mergedCtx.textBaseline = "top";
      mergedCtx.strokeText(speedText, mergedCanvas.width - 20, 20);
      mergedCtx.fillText(speedText, mergedCanvas.width - 20, 20);

      // The mergedCanvas now contains both the chart and speed overlay for this frame.
      await new Promise(resolve => setTimeout(resolve, 50));
      const blob = await new Promise(resolve => mergedCanvas.toBlob(resolve, 'image/png'));
      const buffer = await blob.arrayBuffer();
      await ffmpeg.writeFile(`frame${i.toString().padStart(4, '0')}.png`, new Uint8Array(buffer));
      if ((i+1) % 50 === 0) setMessage(`⏳ Chart overlays: ${(i+1)}/${frameCount} frames...`);
    }

    setMessage("⏳ Composing overlay video...");
    await ffmpeg.exec([
      '-framerate', `${fps}`,
      '-i', 'frame%04d.png',
      '-vf', 'format=yuva420p',
      '-c:v', 'png',
      '-pix_fmt', 'yuva420p',
      'overlay.mov'
    ]);

    setMessage("⏳ Composing final video...");
    // Compose final video with overlay and watermark using new ffmpeg arguments
    await ffmpeg.exec([
      '-i', 'input.mp4',                      // Input video file
      '-i', 'overlay.mov',                   // Overlay with graph + speed text
      '-i', 'watermark.png',                 // Watermark image
      '-filter_complex',                     // Begin filter graph
      [
        '[1:v]scale=iw*4:ih*4[graph];',  // Scale the overlay graph (graph layer)
        '[2:v]scale=iw*1.5:ih*1.5[wm];',         // Scale the watermark image 3x
        '[0:v][graph]overlay=(W-w)/2:H-h-10[tmp];', // Overlay graph near bottom center
        '[tmp][wm]overlay=W-w-10:H-h-10'     // Overlay watermark bottom right
      ].join(''),
      '-s', '960x540',                       // Output video size
      '-r', '24',                            // Frame rate
      '-c:v', 'libx264',                     // Use x264 codec for video
      '-preset', 'ultrafast',                // Fast encoding preset
      '-c:a', 'copy',                        // Copy audio stream without re-encoding
      'output.mp4'                           // Output file name
    ]);

    const outputData = await ffmpeg.readFile('output.mp4');
    const blob = new Blob([outputData.buffer], { type: 'video/mp4' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'overlay_export.mp4';
    a.click();
    URL.revokeObjectURL(url);
    setMessage("✅ Video exported with per-frame overlay.");
    setExportModalState({ isOpen: true, phase: 'done' });
  } catch (error) {
    setExportModalState({ isOpen: true, phase: 'done' });
    console.error("❌ Error exporting overlay video:", error);
    setMessage("❌ Failed to export overlay video.");
  } finally {
    setIsProcessing(false);
  }
};

const startExportOverlay = () => {
  setExportModalState({ isOpen: true, phase: 'start' });
};

const handleExtractGPS = async () => {
  if (!selectedVideoFile) {
    setMessage("❌ No video selected. Please upload a video first.");
    return;
  }

  setIsProcessing(true);
  // Reset progress and clear any prior message
  setProgress(0);
  setMessage("");

  try {
    const fileSize = selectedVideoFile.size;
    const numChunks = Math.ceil(fileSize / CHUNK_SIZE);
    const chunkProgress = new Array(numChunks).fill(0);
    const chunkUploadPromises = [];

    for (let i = 0; i < numChunks; i++) {
      const start = i * CHUNK_SIZE;
      const chunk = selectedVideoFile.slice(start, start + CHUNK_SIZE);
      const chunkRef = ref(storage, `videos/chunks/${selectedVideoFile.name}-${start}`);

      const uploadPromise = new Promise((resolve, reject) => {
        const uploadTask = uploadBytesResumable(chunkRef, chunk);
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            // Update this chunk's progress
            chunkProgress[i] = snapshot.bytesTransferred;
            // Calculate overall progress percentage
            const totalUploaded = chunkProgress.reduce((sum, curr) => sum + curr, 0);
            const overallProgress = Math.min(Math.round((totalUploaded / fileSize) * 100), 100);
            setProgress(overallProgress);
          },
          (error) => {
            console.error("❌ Error uploading chunk:", error);
            reject(error);
          },
          async () => {
            const chunkUrl = await getDownloadURL(uploadTask.snapshot.ref);
            resolve(chunkUrl);
          }
        );
      });
      chunkUploadPromises.push(uploadPromise);
    }

    // Wait for all chunks to upload concurrently
    const uploadedParts = await Promise.all(chunkUploadPromises);

    // Once all chunks are uploaded, update message to show merging status
    setMessage("✅ All chunks uploaded! Merging and extracting GPS...");

    // Trigger Cloud Run processing with the array of chunk URLs
    const response = await fetch("https://gopro-processor-493819678818.us-central1.run.app/process-video", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        fileName: selectedVideoFile.name,
        chunks: uploadedParts,
        userId: user.uid,
      }),
    });

    const json = await response.json();
    if (!response.ok) throw new Error(json.error || "Failed to extract GPS");

    setMessage("✅ GPS Data extracted! Loading telemetry...");

    // Retrieve and parse the CSV telemetry file from Firebase Storage
    const csvFilePath = json.csvPath;
    const csvRef = ref(storage, csvFilePath);
    const csvURL = await getDownloadURL(csvRef);
    const csvResponse = await fetch(csvURL);
    const csvText = await csvResponse.text();
    const parsedTelemetry = parseCSV(csvText);
    setTelemetryData(parsedTelemetry);

    // Cleanup: Delete all uploaded chunks in parallel
    const deletePromises = uploadedParts.map(async (chunkUrl) => {
      const chunkRef = ref(storage, chunkUrl);
      await deleteObject(chunkRef);
    });
    await Promise.all(deletePromises);

    setMessage("✅ Process completed! GPS data loaded.");
  } catch (error) {
    console.error("❌ GPS extraction failed:", error);
    setMessage("❌ GPS extraction failed. Check logs.");
  } finally {
    setIsProcessing(false);
  }
};

  // --------------- HELPER FUNCTIONS ---------------
  const getTelemetryPointForTimestamp = (timestamp, data) => {
    if (!data || data.length === 0) return null;
    return data.reduce((closestPoint, currentPoint) => {
      const closestDiff = Math.abs(closestPoint.time - timestamp);
      const currentDiff = Math.abs(currentPoint.time - timestamp);
      return currentDiff < closestDiff ? currentPoint : closestPoint;
    });
  };

  const initializeDashboardLayers = (data) => {
    if (!mapRef.current || !data || data.length === 0) return;

    // Remove old path if it exists
    if (dashboardLayers.current) {
      mapRef.current.removeLayer(dashboardLayers.current.layer);
    }

    const dashboardLayer = L.layerGroup().addTo(mapRef.current);

    // Plot the path
    const coordinates = data.map((p) => [p.lat, p.lon]);
    const path = L.polyline(coordinates, { color: myColor }).addTo(dashboardLayer);

    // Create the "current position" marker
    const marker = L.circleMarker(coordinates[0], {
      radius: 6,
      color: myColor,
      fillOpacity: 0.9,
    }).addTo(dashboardLayer);

    dashboardLayers.current = { layer: dashboardLayer, marker, path };

    // Zoom map to this path
    mapRef.current.fitBounds(path.getBounds());
  };

  /**
   * Move the "current position" marker to match the video’s time
   */
  function updateDashboardMarker(telemetryTime, masterCoordinate) {
    if (!dashboardLayers.current) return;
    // If a master coordinate is provided, use it.
    if (masterCoordinate && masterCoordinate.lat && masterCoordinate.lon) {
      dashboardLayers.current.marker.setLatLng([masterCoordinate.lat, masterCoordinate.lon]);
    } else if (telemetryData && telemetryData.length > 0) {
      const point = getTelemetryPointForTimestamp(telemetryTime, telemetryData);
      if (point && dashboardLayers.current.marker) {
        dashboardLayers.current.marker.setLatLng([point.lat, point.lon]);
      }
    }
  }


  // New video system handlers
  const handleVideoTimeChange = useCallback((time) => {
    setCurrentVideoTime(time);
    const telemetryTime = time - videoSyncOffset;
    updateDashboardMarker(telemetryTime);
    updateGraphAnnotation(telemetryTime);
    
    // Also call the master time change for synchronization
    onMasterTimeChange(telemetryTime);
  }, [videoSyncOffset, onMasterTimeChange]);

  const handleVideoPlayStateChange = useCallback((state) => {
    setIsVideoPlaying(state === 'playing');
    console.log(`🎬 Video play state changed to: ${state}`);
    
    // Sync with other videos if linked
    if (videosLinked) {
      if (state === 'playing') {
        videoSync.playAllVideos();
      } else if (state === 'paused') {
        videoSync.pauseAllVideos();
      }
    }
  }, [videosLinked, videoSync]);

  const handleVideoSeek = useCallback((time) => {
    setCurrentVideoTime(time);
    const telemetryTime = time - videoSyncOffset;
    updateDashboardMarker(telemetryTime);
    updateGraphAnnotation(telemetryTime);
    
    // Also call the master time change for synchronization
    onMasterTimeChange(telemetryTime);
  }, [videoSyncOffset, onMasterTimeChange]);

  const updateGraphAnnotation = (telemetryTime) => {
    if (!combinedChartRef.current) {
      console.log("❌ updateGraphAnnotation: No chart available");
      return;
    }
    const chart = combinedChartRef.current;
    
    console.log(`📊 updateGraphAnnotation called with telemetryTime: ${telemetryTime}`);
    
    // Update the annotation to the current telemetry time.
    const annotation = chart.options.plugins.annotation.annotations.videoTime;
    annotation.xMin = telemetryTime;
    annotation.xMax = telemetryTime;
    
    // Get the x-axis scale. Adjust the scale id if needed.
    const xScale = chart.options.scales.x;
    
    // Calculate current visible window width.
    const windowWidth = xScale.max - xScale.min;
    
    // We want the annotation to be at 95% of the chart width from the left.
    const desiredPosition = xScale.min + 0.95 * windowWidth;
    
    // If the new telemetry time is beyond this desired position, pan the chart.
    if (telemetryTime > desiredPosition) {
      const shift = telemetryTime - desiredPosition;
      xScale.min += shift;
      xScale.max += shift;
    }
    
    chart.update('none');
  };

  const handleGraphClick = (event, elements) => {
    if (elements.length > 0) {
        const index = elements[0].index;
        const selectedTime = combinedChartRef.current.data.labels[index];
        console.log(`📊 Graph clicked! Seeking to ${selectedTime}s (Dashboard: ${dashboardId})`);

        // Update marker and annotation
        updateDashboardMarker(selectedTime);
        updateGraphAnnotation(selectedTime);
        
        // If we have a video, seek to the corresponding video time
        if (hasVideo) {
          const targetVideoTime = selectedTime + videoSyncOffset;
          handleVideoSeek(targetVideoTime);
        }
        
        // Call master time change for synchronization
        onMasterTimeChange(selectedTime);
    }
  };



  
  // --------------- EFFECTS ---------------

  useEffect(() => {
    console.log("17");
    if (runData && runData.youtubeUrl) {
      setLocalYoutubeUrl(runData.youtubeUrl);
    }
  }, [runData]);

  useEffect(() => {
    console.log("18");
    if (message && !isProcessing) {
      const timer = setTimeout(() => {
        setMessage("");
      }, 5000); // clear message 10 seconds after processing finishes
      return () => clearTimeout(timer);
    }
  }, [message, isProcessing]);


  useEffect(() => {
    console.log("20");
    if (runData && runData.runName) {
      setRunName(runData.runName);
    }
  }, [runData]);








useEffect(() => {
  // Attach functions to `window` for manual debugging
  window.updateGraphAnnotation = updateGraphAnnotation;
  window.updateDashboardMarker = updateDashboardMarker;
}, []);

  /**
   * 4) Whenever we get telemetry data, initialize the path + chart + metrics
   */
  useEffect(() => {
    console.log("27");
    if (telemetryData.length > 0) {
        console.log("📍 Initializing Dashboard Layers...");
        initializeDashboardLayers(telemetryData);
        initializeCombinedChart(telemetryData);
        updateMetrics(telemetryData);
        
        // Register this dashboard's video player with the sync manager
        videoSync.registerVideoPlayer(dashboardId, {
          telemetryData: telemetryData,
          seekTo: handleVideoSeek,
          play: () => setIsVideoPlaying(true),
          pause: () => setIsVideoPlaying(false),
          getCurrentTime: () => currentVideoTime
        });
    } else {
        console.warn("⚠️ No telemetry data. Removing existing paths.");
        if (dashboardLayers.current) {
            mapRef.current.removeLayer(dashboardLayers.current.layer);
            dashboardLayers.current = null;
        }
        
        // Unregister video player when no telemetry data
        videoSync.unregisterVideoPlayer(dashboardId);
    }
}, [telemetryData, dashboardId, videoSync, handleVideoSeek, currentVideoTime]);

  /**
   * 5) On map click, find the nearest lat/lng in this dashboard’s path
   *    and seek the video (local or YouTube) to that time
   */
  useEffect(() => {
    console.log("28");
    const handleMapClick = (e) => {
      if (!telemetryData || telemetryData.length === 0) return;
  
      const { lat, lng } = e.latlng;
    
      let closestPoint = null;
      let minDist = Infinity;
      telemetryData.forEach((p) => {
        const dist = calculateDistance(lat, lng, p.lat, p.lon);
        if (dist < minDist) {
          minDist = dist;
          closestPoint = p;
        }
      });
  
      if (closestPoint) {
        console.log(`📍 Map Clicked! Seeking to time: ${closestPoint.time}s`);
        
        // Update marker and annotation
        updateDashboardMarker(closestPoint.time);
        updateGraphAnnotation(closestPoint.time);
        
        // If we have a video, seek to the corresponding video time
        if (hasVideo) {
          const targetVideoTime = closestPoint.time + videoSyncOffset;
          handleVideoSeek(targetVideoTime);
        }
        
        // Call master time change for synchronization
        onMasterTimeChange(closestPoint.time);
      }
    };
  
    if (mapRef.current) {
      mapRef.current.on("click", handleMapClick);
    }
  
    return () => {
      if (mapRef.current) {
        mapRef.current.off("click", handleMapClick);
      }
    };
  }, [telemetryData, mapRef]);

  
  useEffect(() => {
    console.log("29");
    if (activeTab === "graph" && telemetryData.length > 0) {
      setTimeout(() => {
        initializeCombinedChart(telemetryData);
      }, 100);
    }
  }, [activeTab, telemetryData, dashboardId]);

  // Ensure chart is available when entering fullscreen
  useEffect(() => {
    if (isFullscreen && activeTab === "graph" && telemetryData.length > 0) {
      // Wait a bit for the DOM to update
      setTimeout(() => {
        const canvasEl = document.getElementById(`combinedGraph-${dashboardId}`);
        if (canvasEl) {
          console.log("🔄 Fullscreen mode - ensuring chart is available");
          // Always reinitialize chart in fullscreen to ensure it's on the right canvas
          initializeCombinedChart(telemetryData);
        }
      }, 200);
    }
  }, [isFullscreen, activeTab, telemetryData, dashboardId]);

  // --------------- HANDLERS ---------------
  useEffect(() => {
    console.log("31");
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);


  /**
   *  Drag/drop: if video => load video file, if CSV => parse and setTelemetryData
   */
  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.classList.add('dragover');
  };
  const handleDragLeave = (e) => {
    e.currentTarget.classList.remove('dragover');
  };
  const handleDrop = (e) => {
    e.preventDefault();
    e.currentTarget.classList.remove("dragover");
    const file = e.dataTransfer.files[0];
    if (!file) return;
  
    if (file.type.startsWith("video/")) {
      // Set the file in state
      setSelectedVideoFile(file);
      console.log(file);
console.log(file instanceof File); // should be true
console.log(file.name, file.size, file.type);
      handleExtractGPMD(file);
      return;
    }
  
    if (file.name.endsWith(".csv")) {
      handleTelemetryFile({ target: { files: [file] } });
    } else if (file.name.endsWith(".gpx")) {
      handleGpxFile(file);
    } else if (file.name.endsWith(".fit")) {
      handleFitFile(file);
    }
  };

  const handleTelemetryFile = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) => {
      const text = e.target.result;
      const parsedData = parseCSV(text);
      setTelemetryData(parsedData);
      onChildTelemetry(parsedData);
    };
    reader.readAsText(file);
  };

  function handleGpxFile(file) {
    const reader = new FileReader();
    reader.onload = (e) => {
      const gpxText = e.target.result;
      const parsed = parseGPX(gpxText);
      setTelemetryData(parsed); // same place you set CSV data
      onChildTelemetry(parsed);
    };
    reader.readAsText(file);
  }
  
  function parseGPX(gpxText) {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(gpxText, "application/xml");
  
    // Gather all <trkpt> elements
    const trkpts = [...xmlDoc.getElementsByTagName("trkpt")];
  
    const results = trkpts.map((trkpt) => {
      const lat = parseFloat(trkpt.getAttribute("lat"));
      const lon = parseFloat(trkpt.getAttribute("lon"));
  
      // Elevation:
      const eleTag = trkpt.getElementsByTagName("ele")[0];
      const elevation = eleTag ? parseFloat(eleTag.textContent) : 0;
  
      // Time (convert to seconds from start if you like, or keep as a Date):
      const timeTag = trkpt.getElementsByTagName("time")[0];
      const timeString = timeTag ? timeTag.textContent : null;
      const timeMs = timeString ? Date.parse(timeString) : null;
  
      // For demonstration, let’s store the actual epoch seconds:
      // We can post-process it to "seconds from the start" if needed
      let timeSec = null;
      if (timeMs) {
        timeSec = timeMs / 1000.0; // epoch seconds
      }
  
      // Heart rate in <gpxtpx:hr>:
      const hrTag = trkpt.getElementsByTagName("gpxtpx:hr")[0];
      const heartRate = hrTag ? parseFloat(hrTag.textContent) : null;
  
      // If speed is provided in an extension, parse it similarly. 
      // Otherwise, you can compute speed from distance/time differences:
      // This example doesn’t show <speed> from GPX by default. 
      // Some tools put them in <extensions>. 
      // For now, we'll set speed to 0, then compute it later if you want
      const speed = 0;
  
      // Possibly parse power if your GPX exporter includes it:
      let power = 0;
      const extTag = trkpt.getElementsByTagName("extensions")[0];
      if (extTag) {
        const powerTag = extTag.getElementsByTagName("power")[0];
        if (powerTag) {
          power = parseFloat(powerTag.textContent) || 0; // now valid
        }
      }
      
      return {
        lat,
        lon,
        elevation,
        time: timeSec,    // or time in seconds from start
        speed,            // might be 0 if not provided in GPX
        heartRate,        // extra field
        power,            // extra field
      };
    });
  
    // Optionally you may want to shift all times so that the earliest trackpoint = time 0
    if (results.length > 0 && results[0].time) {
      const startTime = results[0].time;
      results.forEach((r) => {
        if (r.time) {
          r.time = r.time - startTime; // so first data point is time=0
        }
      });
    }
    for (let i = 1; i < results.length; i++) {
      const prev = results[i - 1];
      const curr = results[i];
      const distMeters = calculateDistance(prev.lat, prev.lon, curr.lat, curr.lon);
      const dt = curr.time - prev.time; // in seconds
      
      // Convert m/s to km/h => multiply by 3.6
      if (dt > 0) {
        const speedKmh = (distMeters / dt) * 3.6;
        curr.speed = speedKmh;
      }
    }
    return results;
  }

  function handleFitFile(file) {
    const reader = new FileReader();
    reader.onload = (e) => {
      const arrayBuffer = e.target.result;
      parseFit(arrayBuffer);
    };
    reader.readAsArrayBuffer(file);
  }
  
  function parseFit(arrayBuffer) {
    const fitParser = new FitParser({
      force: true,
      speedUnit: "km/h",
      lengthUnit: "km",
      temperatureUnit: "celcius",
      elapsedRecordField: true,
    });
    fitParser.parse(arrayBuffer, (error, data) => {
      if (error) {
        console.error("FIT parse error:", error);
        return;
      }
  
      console.log("FIT data:", data);
      if (!data.records) {
        console.error("No records found in FIT file.");
        return;
      }
  
      const startTs = new Date(data.records[0].timestamp).getTime() / 1000;
  
      const result = data.records
        // skip records with no lat/lon if needed
        .filter(r => r.position_lat !== undefined && r.position_long !== undefined)
        .map(r => {
          const t = new Date(r.timestamp).getTime() / 1000; // epoch seconds
          return {
            time: t - startTs,                 // time=0 at first record
            lat: r.position_lat,
            lon: r.position_long,
            speed: r.speed,
            heartRate: r.heart_rate,
            power: r.power,
            elevation: r.altitude,
          };
        });
  
      result.sort((a, b) => a.time - b.time);
      setTelemetryData(result);
    });
  }

  /**
   * If you want to load YouTube from user input
   */
  const loadYoutubeVideo = () => {
    const videoId = extractYouTubeVideoID(youtubeUrl);
    if (videoId) {
      // This function is no longer needed with the new video system
      console.log('YouTube video loading is now handled by UnifiedVideoPlayer');
    } else {
      alert('Invalid YouTube URL. Please try again.');
    }
  };
  const extractYouTubeVideoID = (url) => {
    const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(regex);
    return match ? match[1] : null;
  };

  const fetchYouTubeDirectUrl = async (videoId) => {
    try {
      const API_KEY = "AIzaSyBFyx7VqIMzBWvILQfYIL84syCi8CHtZNE";
      const apiUrl = `https://www.googleapis.com/youtube/v3/videos?id=${videoId}&key=${API_KEY}&part=contentDetails`;
  
      const response = await fetch(apiUrl);
      const data = await response.json();
  
      if (data.items.length > 0) {
        // YouTube does not provide direct URLs; alternative methods needed.
        return `https://www.youtube.com/get_video_info?video_id=${videoId}`;
      } else {
        console.error("YouTube video data not found.");
        return null;
      }
    } catch (error) {
      console.error("Error fetching YouTube video data:", error);
      return null;
    }
  };

  // --------------- CSV and Chart ---------------
// Updated parseCSV function to support BYB file format
const parseCSV = (text) => {
  // Detect delimiter: use semicolon if there are more semicolons than commas.
  let delimiter = ",";
  const commaCount = text.split(",").length;
  const semicolonCount = text.split(";").length;
  if (semicolonCount > commaCount) {
    delimiter = ";";
  }

  const lines = text.trim().split("\n");
  if (lines.length < 2) return [];

  // Split the header line.
  const headers = lines[0].split(delimiter).map(h => h.trim());
  
  // Determine file type.
  // BYB file headers: Time, Fork, Shock, Fbrake, Rbrake, Speed, AccX, AccY, AccZ, GyroX, GyroY, GyroZ, Latitude, Longitude, Altitude, gpsSpeed
  const isBYB = headers.includes("Fork") && headers.includes("Shock") &&
                headers.includes("Fbrake") && headers.includes("Rbrake");
  // DAQ (data acquisition) format: count, time, front_disp, rear_disp, gps_long, gps_lat, gps_speed, flag, acc_frame_*, gyro_frame_*, ...
  const isDAQ = headers.includes("front_disp") && headers.includes("rear_disp") &&
                headers.includes("gps_long") && headers.includes("gps_lat") && headers.includes("gps_speed");
  // BrakeAce export format: timestamp_ms, latitude, longitude, elevation_m, speed_m_s, front_brake_power_w, rear_brake_power_w, ...
  const isBrakeAce = headers.includes("timestamp_ms") && headers.includes("latitude") && headers.includes("longitude");

  // Setup header mapping.
  let headerMap = {};
  if (isBrakeAce) {
    headerMap = {
      "timestamp_ms": "time",
      "latitude": "lat",
      "longitude": "lon",
      "elevation_m": "elevation",
      "speed_m_s": "speed",
      "front_brake_power_w": "front_brake",
      "rear_brake_power_w": "rear_brake",
      "front_brake_force": "front_brake_force",
      "rear_brake_force": "rear_brake_force",
      "front_lever_brake_force": "front_lever_brake_force",
      "rear_lever_brake_force": "rear_lever_brake_force"
    };
  } else if (isBYB) {
    headerMap = {
      "Time": "time",
      "Fork": "fork",
      "Shock": "shock",
      "Fbrake": "front_brake",
      "Rbrake": "rear_brake",
      "Speed": "speed",
      "AccX": "accel_x",
      "AccY": "accel_y",
      "AccZ": "accel_z",
      "GyroX": "gyro_x",
      "GyroY": "gyro_y",
      "GyroZ": "gyro_z",
      "Latitude": "lat",
      "Longitude": "lon",
      "Altitude": "elevation",
      "gpsSpeed": "gps_speed"
    };
  } else if (isDAQ) {
    headerMap = {
      "time": "time",
      "front_disp": "fork",
      "rear_disp": "shock",
      "gps_long": "lon",
      "gps_lat": "lat",
      "gps_speed": "speed",
      "acc_frame_x": "accel_x",
      "acc_frame_y": "accel_y",
      "acc_frame_z": "accel_z",
      "gyro_frame_x": "gyro_x",
      "gyro_frame_y": "gyro_y",
      "gyro_frame_z": "gyro_z"
    };
  } else {
    headerMap = {
      "Time (s)": "time",
      "Distance (m)": "distance",
      "Latitude (deg)": "lat",
      "Longitude (deg)": "lon",
      "Elevation (m)": "elevation",
      "Speed (km/h)": "speed",
      "Front Brake Power (W)": "front_brake",
      "Rear Brake Power (W)": "rear_brake"
    };
  }

  // Build a mapping of our field keys to column indices.
  const colMap = {};
  headers.forEach((header, index) => {
    if (headerMap[header]) {
      colMap[headerMap[header]] = index;
    }
  });

  const data = [];
  for (let i = 1; i < lines.length; i += 1) {
    const values = lines[i].split(delimiter);
    if (values.length < headers.length) continue;
    const row = {};
    for (const [key, idx] of Object.entries(colMap)) {
      const v = values[idx].trim();
      const num = parseFloat(v);
      row[key] = isNaN(num) ? v : num;
    }
    // Include rows with basic telemetry data.
    if (row.time !== undefined && row.lat !== undefined && row.lon !== undefined && row.speed !== undefined) {
      data.push(row);
    }
  }
  
  // For BYB and DAQ files, normalize fork and shock values (DAQ: front_disp/rear_disp in mm).
  if ((isBYB || isDAQ) && data.length > 0) {
    const forkValues = data.map(r => r.fork).filter(v => typeof v === "number");
    const shockValues = data.map(r => r.shock).filter(v => typeof v === "number");

    if (forkValues.length > 0) {
      const minFork = forkValues.reduce((min, v) => (v < min ? v : min), Infinity);
      const maxFork = forkValues.reduce((max, v) => (v > max ? v : max), -Infinity);
      data.forEach(r => {
        if (typeof r.fork === "number" && maxFork !== minFork) {
          r.fork_normalized = (r.fork - minFork) / (maxFork - minFork);
        }
      });
    }
    if (shockValues.length > 0) {
      const minShock = shockValues.reduce((min, v) => (v < min ? v : min), Infinity);
      const maxShock = shockValues.reduce((max, v) => (v > max ? v : max), -Infinity);
      data.forEach(r => {
        if (typeof r.shock === "number" && maxShock !== minShock) {
          r.shock_normalized = (r.shock - minShock) / (maxShock - minShock);
        }
      });
    }
  }

  // BrakeAce export: timestamp_ms -> seconds, speed_m_s -> km/h
  if (isBrakeAce && data.length > 0) {
    data.forEach(r => {
      if (typeof r.time === "number") r.time = r.time / 1000;
      if (typeof r.speed === "number") r.speed = r.speed * 3.6;
    });
  }
  
  // Sort data by time.
  data.sort((a, b) => a.time - b.time);
  return data;
};

  const initializeCombinedChart = (data) => {
    const canvasEl = document.getElementById(`combinedGraph-${dashboardId}`);
    if (!canvasEl) {
      console.warn("initializeCombinedChart: Canvas element not found; skipping initialization.");
      return;
    }
    
    console.log(`📊 Initializing chart on canvas: ${canvasEl.id}, isFullscreen: ${isFullscreen}`);
    
    // Only skip reinitialization if we're not in fullscreen mode
    if (combinedChartRef.current && combinedChartRef.current.data && combinedChartRef.current.data.labels.length > 0 && !isFullscreen) {
      console.log("Chart already exists with data, skipping reinitialization");
      return;
    }
    
    const ctx = canvasEl.getContext('2d');
    
    // Destroy previous chart instance if exists
    if (combinedChartRef.current) {
      combinedChartRef.current.destroy();
    }

    const timeData = data.map(d => d.time);
// Compute raw speed values in km/h:
const rawSpeedData = data.map(d => d.speed * 3.6);
// Compute the maximum speed (avoid zero to prevent division by zero):
const maxSpeed = Math.max(...rawSpeedData, 1);
// Normalize speed data to a range (here 0–1000):
const normalizedSpeedData = rawSpeedData.map(s => (s / maxSpeed) * 1000);

    const frontBrakeData = data.map(d => d.front_brake);
    const rearBrakeData = data.map(d => d.rear_brake);
    const heartRateData = data.map(d => d.heartRate || 0);
    const powerData = data.map(d => d.power*20 || 0);
    const forkData = data.map(d => (typeof d.fork_normalized === 'number' ? d.fork_normalized * 100 : null));
    const shockData = data.map(d => (typeof d.shock_normalized === 'number' ? d.shock_normalized * 100 : null));
   
    // const ctx = document.getElementById(`combinedGraph-${dashboardId}`).getContext('2d');
    combinedChartRef.current = new Chart(ctx, {
      type: 'line',
      data: {
        labels: timeData,
        datasets: [
          { label: 'Speed (km/h)', data: normalizedSpeedData, borderColor: '#d9534f', fill: true,pointStyle: 'line',borderWidth: 3  },
          { label: 'Front Brake Power (W)', data: frontBrakeData, borderColor: '#b8d419', fill: false,pointStyle: 'line',borderWidth: 3 },
          { label: 'Rear Brake Power (W)', data: rearBrakeData, borderColor: '#1385a8', fill: false,pointStyle: 'line',borderWidth: 3  },
          {
            label: 'Heart Rate (bpm)',
            data: heartRateData,
            borderColor: '#d777a6',
            fill: false,
            pointStyle: 'line',
            borderWidth: 3 
          },
          {
            label: 'Power (W)',
            data: powerData,
            borderColor: '#6a5cb8',
            fill: false,
            pointStyle: 'line',
            borderWidth: 3 
          },
          { label: 'Fork Position (%)', data: forkData, borderColor: '#007bff', fill: false, pointStyle: 'line', borderWidth: 3 },
          { label: 'Shock Position (%)', data: shockData, borderColor: '#28a745', fill: false, pointStyle: 'line', borderWidth: 3 },
      
        ],
      },
      options: {
        responsive: true,
        scales: {
          x: {
            type: 'linear',
            ticks: { maxTicksLimit: 20, display: false, color: '#aaa'  },
            title: { display: true, text: 'Time (s)' , color: '#aaa' },
            grid: { color: '#444'},
          },
          y: {
            ticks: { maxTicksLimit: 20, display: false , color: '#aaa' },
            title: { display: true, text: 'Value' , color: '#aaa'},
            grid: { color: '#2a2a2a'},
          },
        },
        plugins: {
          legend: {
            labels: {
              usePointStyle: true,
              color: '#aaa'
            }
          },
          zoom: {
            pan: { enabled: true, mode: 'x' },
            zoom: {
              wheel: { enabled: true },
              pinch: { enabled: true },
              mode: 'x',
            },
          },
          annotation: {
            annotations: {
              videoTime: {
                type: 'line',
                xMin: 0,
                xMax: 0,
                borderColor: 'white',
                borderWidth: 2,
                label: { content: 'Now', enabled: true, position: 'top', color: 'white', backgroundColor: '#000' },
              },
            },
          },
          tooltip: {
            callbacks: {
              title: (tooltipItems) => {
                if (tooltipItems && tooltipItems.length > 0) {
                  return "Timestamp: " + tooltipItems[0].label + " sec";
                }
                return "";
              },
              label: (context) => {
                const scaledValue = context.parsed.y;
                if (context.dataset.label === 'Speed (km/h)') {
                  // Convert normalized value back to original raw speed:
                  const originalSpeed = (scaledValue / 1000) * maxSpeed;
                  return `Speed: ${originalSpeed.toFixed(1)} km/h`;
                } else if (context.dataset.label === 'Power (W)') {
                  const originalPower = scaledValue / 20;
                  return `Power: ${originalPower.toFixed(1)} W`;
                }
                return `${context.dataset.label}: ${scaledValue.toFixed(1)}`;
              },
            },
          },
        },
        onClick: handleGraphClick,
      },
    });

    // Sync chart annotation with video
    // if (videoRef.current) {
    //   videoRef.current.addEventListener('timeupdate', () => {
    //     const t = videoRef.current.currentTime;
    //     combinedChartRef.current.options.plugins.annotation.annotations.videoTime.xMin = t;
    //     combinedChartRef.current.options.plugins.annotation.annotations.videoTime.xMax = t;
    //     combinedChartRef.current.update('none');
    //   });
    // }

    // Always show the annotation on chart image export
    if (
      combinedChartRef.current &&
      combinedChartRef.current.options &&
      combinedChartRef.current.options.plugins &&
      combinedChartRef.current.options.plugins.annotation &&
      combinedChartRef.current.options.plugins.annotation.annotations &&
      combinedChartRef.current.options.plugins.annotation.annotations.videoTime
    ) {
      combinedChartRef.current.options.plugins.annotation.annotations.videoTime.display = true;
    }
  };

 

  /**
   * Update textual metrics
   */
  const updateMetrics = (data) => {
    if (!data.length) return;
    
    // Only update metrics if the metrics tab is active
    if (activeTab !== "metrics") return;
  
    const totalDistance =
      data[data.length - 1].totalDistance ||
      data.reduce((sum, point, i) => {
        if (i === 0) return 0;
        return sum + calculateDistance(
          data[i - 1].lat, data[i - 1].lon,
          point.lat, point.lon
        );
      }, 0);
  
    const totalElevationLoss = data.reduce((acc, point, i) => {
      if (i > 0 && point.elevation && data[i - 1].elevation) {
        const diff = data[i - 1].elevation - point.elevation;
        return diff > 0 ? acc + diff : acc;
      }
      return acc;
    }, 0);
  
    // Calculate braking metrics...
    const totalTimeBrakingFront = data.filter(p => p.front_brake > 0).length;
    const totalTimeBrakingRear = data.filter(p => p.rear_brake > 0).length;
    const totalTimeBraking = totalTimeBrakingFront + totalTimeBrakingRear;
    const totalFrontPower = data.reduce((sum, p) => sum + (p.front_brake || 0), 0);
    const totalRearPower = data.reduce((sum, p) => sum + (p.rear_brake || 0), 0);
    const totalPower = totalFrontPower + totalRearPower;
    const proportionFront = totalPower > 0 ? ((totalFrontPower / totalPower) * 100).toFixed(1) : 0;
    const proportionRear = totalPower > 0 ? ((totalRearPower / totalPower) * 100).toFixed(1) : 0;
    
    // Helper function: safely update an element's text content
    const safeSetTextContent = (id, text) => {
      const el = document.getElementById(`${id}-${dashboardId}`);
      if (el) {
        el.textContent = text;
      } else {
        console.warn(`Element with id ${id}-${dashboardId} not found.`);
      }
    };
  
    safeSetTextContent("total-distance", (totalDistance / 1000).toFixed(2));
    safeSetTextContent("total-elevation-loss", totalElevationLoss.toFixed(2));
    safeSetTextContent("total-time-braking-front", totalTimeBrakingFront);
    safeSetTextContent("total-time-braking-rear", totalTimeBrakingRear);
    safeSetTextContent("total-time-braking", totalTimeBraking);
    safeSetTextContent("proportion-power", `${proportionFront}% / ${proportionRear}%`);
    
    // Optionally update max braking force metrics if their elements exist:
    const maxFrontPower = Math.max(...data.map(d => d.front_brake || 0));
    const maxRearPower = Math.max(...data.map(d => d.rear_brake || 0));
    const maxBrakingForceVal = Math.max(maxFrontPower, maxRearPower);
    const maxTypeEl = document.getElementById(`max-braking-type-${dashboardId}`);
    const maxForceEl = document.getElementById(`max-braking-force-${dashboardId}`);
    if (maxForceEl) {
      maxForceEl.textContent = maxBrakingForceVal.toFixed(1);
    }
    if (maxTypeEl) {
      let maxType = "";
      if (maxBrakingForceVal <= 0) {
        maxType = "None";
      } else if (maxFrontPower > maxRearPower) {
        maxType = "Front";
      } else if (maxRearPower > maxFrontPower) {
        maxType = "Rear";
      } else {
        maxType = "Equal";
      }
      maxTypeEl.textContent = maxType;
    }
  };

  /**
   * Calculate great-circle distance between lat/lng
   */
  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371e3;
    const phi1 = (lat1 * Math.PI) / 180;
    const phi2 = (lat2 * Math.PI) / 180;
    const deltaPhi = ((lat2 - lat1) * Math.PI) / 180;
    const deltaLambda = ((lon2 - lon1) * Math.PI) / 180;

    const a =
      Math.sin(deltaPhi / 2) ** 2 +
      Math.cos(phi1) * Math.cos(phi2) * Math.sin(deltaLambda / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };

   /**
   * Finds the nearest point in THIS telemetry array to (targetLat, targetLon)
   */
   const findNearestTelemetryPoint = (targetLat, targetLon) => {
    if (!telemetryData || telemetryData.length === 0) return null;
    let closest = null;
    let minDist = Infinity;
    for (let i = 0; i < telemetryData.length; i++) {
      const p = telemetryData[i];
      const dist = calculateDistance(targetLat, targetLon, p.lat, p.lon);
      if (dist < minDist) {
        minDist = dist;
        closest = p;
      }
    }
    return closest;
  };

  const unloadVideo = () => {
    // Clear the selected video file
    setSelectedVideoFile(null);
    
    // Reset video-related state
    setCurrentVideoTime(0);
    setIsVideoPlaying(false);
    
    // Clear the local YouTube URL so that the YouTube video element is removed.
    setLocalYoutubeUrl(null);
  };
  
  const unloadData = () => {
    setTelemetryData([]);
  };

  // -------------------------------------------------------------
  // The rest of your Dashboard code: video drop, marker, chart, etc.
  // (omitted here for brevity — your existing code should remain)
  // -------------------------------------------------------------

 
  return (
    
    <div className="super-dashboard-container">
      <div className="dashboard-container"
       style={{
        display: "BLOCK",
        padding: "0px",
        border: `2px solid`,
        borderColor: myColor,
        borderRadius: "8px",
        backgroundColor: "#222",
        margin: "0px 0px",
        maxWidth: "800px",
        }}>


        <div className="left-column">
        {(selectedVideoFile || telemetryData.length > 0) && (
        <div id="save-run" className="save-run">
  {/* Styled Input - Default Name Format */}
  <div style={{ position: "relative", display: "inline-block" }}>
  <div
      style={{
        cursor: "pointer",
        marginRight: "5px",
      }}
      onClick={toggleMenu}
    >
      {/* You can use an actual icon library or just text. Example: */}
      &#8942; {/* HTML entity for vertical ellipsis */}
    </div>
   

  {/* The "dropdown" menu, absolutely positioned, only visible if menuOpen=true */}
  {menuOpen && (
    <div
      style={{
        position: "absolute",
        top: "30px", // a bit below the icon
        left: "0px", // or align to the icon's left
        background: "#fff",
        width: "auto",
        border: "1px solid #ccc",
        borderRadius: "4px",
        padding: "10px 10px",
        zIndex: 9999,
        lineHeight: "25px",
        color: "#222",
      }}
    >
      {/* Conditionally render menu items */}
      {hasVideo && (
        <> 
        {/* <div
          style={{ marginBottom: "5px", cursor: "pointer" }} >
         <span onClick={() => {
            toggleMenu();
            handleExtractGPS();
          }} >Extract GPS Data </span>&nbsp;
          <span style={{ fontSize: "14px", color: "#666" }}>
      (only for some GPS-enabled cameras)
    </span>
    <Tooltip textKey="extractgps" />
        </div>  */}
                <div
                style={{ marginBottom: "5px", cursor: "pointer" }} >
               <span onClick={() => {
                  toggleMenu();
                  handleExtractGPMD();
                }} >📈 Extract Data </span>&nbsp;
                <span style={{ fontSize: "14px", color: "#666" }}>
            (only for some GPS-enabled cameras)
          </span>
          <Tooltip textKey="extractgps" />
              </div> 

              <div
                style={{ marginBottom: "5px", cursor: "pointer" }} >
               <span onClick={() => {
                  toggleMenu();
                  handleDataMixer();
                }} >➕ Add More Data (not availiable yet)</span>&nbsp;
          <Tooltip textKey="openDataMixer" />
              </div> 
              <div
                style={{ marginBottom: "5px", cursor: "pointer" }} >
               <span onClick={() => {
                  toggleMenu();
                  startExportOverlay();
                }} >📹 Export Video with Data Overlay</span>&nbsp;
          <Tooltip textKey="openExportVideo" />
              </div> 

            </>
      )}
      {hasVideo && hasData && (
       <><hr/> <div
          style={{ marginBottom: "5px", cursor: "pointer" }}>
          <span onClick={() => {toggleMenu();handleSyncData();}}>Sync Data</span> <Tooltip textKey="syncData" />
        </div>
        </>
      )}
      {/* You could add more actions if desired */}
    </div>
  )}</div>
  <input
    type="text"
    className="save-run-input"
    value={runName}
    onChange={(e) => setRunName(e.target.value)}
    placeholder={placeholderName}
     />

  {/* Upload to YouTube Checkbox */}
  <label className="save-run-checkbox">
    <input
      type="checkbox"
      checked={uploadToYouTube}
      onChange={(e) => setUploadToYouTube(e.target.checked)}
    />
    Upload Videos<Tooltip textKey="uploadToYouTube" />
  </label>

  {/* Buttons */}
  <button className="save-run-btn" onClick={handleSaveRun} disabled={isProcessing}>
    {isProcessing ? "Processing..." : "Save Run"} ({creditCosts.SAVE_RUN}⚡)
  </button>
  <button
    style={{ marginLeft: "10px", padding: "10px", backgroundColor: "transparent", color: "#999", border: "none", borderRadius: "5px" }}
    onClick={handleFullscreenToggle}
  >
    <FontAwesomeIcon icon={faExpand} onClick={handleFullscreenToggle} />
  </button>
  { hasVideo && (
    <FontAwesomeIcon
                    icon={faTimes}
                    className="tooltip-close-btn"
                    onClick={unloadVideo}
                  />
)}

</div>)}

<div ref={fullScreenContainerRef} style={{ 
  position: "relative",    
  width: isFullscreen ? "100%" : "auto",
  height: isFullscreen ? "100%" : "auto" }}>
  {/* Video Section */}
  {hasVideo && (
    <div className="video-section" 
    style={{
      height: isFullscreen ? "100%" : "auto",

    }}
    >
{/* Unified Video Player */}
{(selectedVideoFile || runData?.youtubeUrl) && (
  <UnifiedVideoPlayer
    videoType={selectedVideoFile ? 'local' : 'youtube'}
    videoUrl={selectedVideoFile ? URL.createObjectURL(selectedVideoFile) : null}
    youtubeUrl={runData?.youtubeUrl}
    currentTime={currentVideoTime}
    onTimeChange={handleVideoTimeChange}
    onPlayStateChange={handleVideoPlayStateChange}
    onSeek={handleVideoSeek}
    dashboardId={dashboardId}
    telemetryData={telemetryData}
    style={{
      width: "100%",
      height: isFullscreen ? "100%" : "450px",
      marginBottom: isFullscreen ? "0" : "10px"
    }}
  />
)}
{/* Graph Overlay for Fullscreen Mode */}
{isFullscreen && telemetryData.length > 0 && (
  <div
    style={{
      position: "absolute",
      bottom: "20px",
      left: "50%",
      transform: "translateX(-50%)",
      width: "600px",
      height: "300px",
      background: "rgba(0,0,0,0.8)",
      zIndex: 1500,
      padding: "10px",
      borderRadius: "8px",
      pointerEvents: "auto", // Allow interaction with chart
    }}
  >
    <canvas 
      id={`combinedGraph-${dashboardId}`}
      style={{
        width: "100%",
        height: "100%",
        display: "block",
      }}
    />
  </div>
)}
    </div>
  )}

    {/* Graph Canvas – For Non-Fullscreen Mode */}
    {!isFullscreen && (
    <div style={{ marginTop: "10px" }}>
      {/* Tab Header */}
      <div
        className="tab-header"
        style={{
          borderBottom: "1px solid #ccc",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <span
          onClick={() => setActiveTab("graph")}
          style={{
            padding: "10px 20px",
            cursor: "pointer",
            color: activeTab === "graph" ? "#fff" : "#888",
            borderBottom: activeTab === "graph" ? "3px solid #000" : "none",
          }}
        >
          Graph
        </span>
        <span
          onClick={() => setActiveTab("metrics")}
          style={{
            padding: "10px 20px",
            cursor: "pointer",
            color: activeTab === "metrics" ? "#fff" : "#888",
            borderBottom: activeTab === "metrics" ? "3px solid #000" : "none",
          }}
        >
          Stats
        </span>
        { hasData && (
         <div style={{ position: "block",width: "100%", height: "50px",textAlign: "right", margin: "10px"  }}><FontAwesomeIcon
                        icon={faTimes}
                        className="tooltip-close-btn"
                        onClick={unloadData}
                      /></div>
        )}
      </div>

      {/* Graph Canvas */}
      { (telemetryData.length > 0 && activeTab === "graph") && (
        <div
          style={{
            width: "100%",
            height: "250px",
            marginTop: "10px"
          }}
        >
          <canvas id={`combinedGraph-${dashboardId}`}></canvas>
        </div>
      )}
    </div>
    )}


  {/* Fullscreen Exit Button */}
  {isFullscreen && (
    <button
      onClick={handleFullscreenToggle}
      style={{
        position: "absolute",
        top: "10px",
        right: "10px",
        zIndex: 2000,
        padding: "8px",
        backgroundColor: "#dc3545",
        color: "#fff",
        border: "none",
        borderRadius: "4px",
      }}
    >
      <FontAwesomeIcon icon={faMinimize} /> Exit Fullscreen
    </button>
  )}
</div>

  
{(!hasData || !hasVideo) && (
<div id="drop-area"
  className="drop-area"
  onDragOver={handleDragOver}
  onDragLeave={handleDragLeave}
  onDrop={handleDrop}
  onClick={() => document.getElementById(`file-input-${dashboardId}`).click()}
>
{(!hasVideo && !hasData) && (
    <p>Drag/drop a video or data file (CSV, GPX, FIT) here or click to select.</p>
  )}

  {(hasData && !hasVideo) && (
    <p>Data is loaded. Drag/drop or click to select a video file.</p>
  )}

  {(!hasData && hasVideo) && (
    <p>Video is loaded. Drag/drop or click to select a data file.</p>
  )}

  {(hasData && hasVideo) && (
    <p>Video & data both loaded. Drop a new file to replace them or click to select.</p>
  )}

  {/* File Input */}
  <input
    id={`file-input-${dashboardId}`}
    type="file"
    accept="video/*,.csv"
    style={{ display: 'none' }}
    onChange={(e) => {
  const file = e.target.files[0];
  if (!file) return;

  if (file.type.startsWith('video/')) {
    setSelectedVideoFile(file);
  } else if (file.name.endsWith('.csv')) {
    handleTelemetryFile({ target: { files: [file] } });
  }
}}
  />
</div>
 )}

         
        </div>

        { telemetryData.length>0 && <div className="right-column">


          <div className="tab-container" style={{ marginTop: "10px" }}>
 

  {/* Tab Content */}
  <div className="tab-content" style={{ padding: "10px" }}>

    {activeTab === "metrics" && (
      <div className="metrics">
        <ul>
          <li>
            Total Distance: <span id={`total-distance-${dashboardId}`}>0</span> km
          </li>
          <li>
            Total Elevation Loss:{" "}
            <span id={`total-elevation-loss-${dashboardId}`}>0</span> m
          </li>
          <li>
            Total Time Spent Braking (Front):{" "}
            <span id={`total-time-braking-front-${dashboardId}`}>0</span> s
          </li>
          <li>
            Total Time Spent Braking (Rear):{" "}
            <span id={`total-time-braking-rear-${dashboardId}`}>0</span> s
          </li>
          <li>
            Total Time Spent Braking:{" "}
            <span id={`total-time-braking-${dashboardId}`}>0</span> s
          </li>
          <li>
            Proportion of Power (Front/Rear):{" "}
            <span id={`proportion-power-${dashboardId}`}>0% / 0%</span>
          </li>
          <li>
            Max Braking Force: <span id={`max-braking-force-${dashboardId}`}>0</span>{" "}
            W (<span id={`max-braking-type-${dashboardId}`}></span>)
          </li>
        </ul>
      </div>
    )}
  </div>
</div>



        </div>}
        <ModalPopup
  isOpen={exportModalState.isOpen}
  title="Export Video with Data Overlay"
  message={
    exportModalState.phase === 'start'
      ? "You can export your video with a stats overlay. This might take a while depending on your video length."
      : exportModalState.phase === 'progress'
      ? "⏳ Exporting video, please wait..."
      : "✅ Export complete!"
  }
  showSpinner={exportModalState.phase === 'progress'}
  onClose={() => setExportModalState({ isOpen: false, phase: 'start' })}
  onCancel={
    exportModalState.phase === 'start'
      ? () => setExportModalState({ isOpen: false, phase: 'start' })
      : null
  }
  onConfirm={
    exportModalState.phase === 'start'
      ? () => handleExportOverlay()
      : null
  }
  confirmLabel={exportModalState.phase === 'start' ? 'Export' : 'Close'}
  cancelLabel="Cancel"
>
  {exportModalState.phase === 'start' && (
    <img src="/export-preview.png" alt="Export Preview" style={{ width: '100%', marginBottom: 10 }} />
  )}
</ModalPopup>

        <ModalPopup
  isOpen={modalState.isOpen}
  title="Data Extraction"
  message={
    modalState.status === 'loading'
      ? '⏳ Extracting Data...'
      : modalState.status === 'no-data'
      ? '❌ No Data Found.'
      : '✅ Data Found.'
  }
  showSpinner={modalState.status === 'loading'}
  onClose={() => setModalState({ isOpen: false, status: '' })}
  onCancel={
    modalState.status === 'loading'
      ? () => {
        gpmdCancelRef.current = true;
          setModalState({ isOpen: false, status: '' });
          setIsProcessing(false);
        }
      : null
  }
  onConfirm={
    modalState.status === 'data-found'
      ? () => setModalState({ isOpen: false, status: '' })
      : null
  }
  onDiscard={
    modalState.status === 'data-found'
      ? () => {
          setTelemetryData([]); // discard telemetry
          setModalState({ isOpen: false, status: '' }); // close modal
        }
      : null
  }
/>
        {(isProcessing || message) && (

  <div
    className="toast-message"
    style={{
      position: "fixed",
      bottom: "20px",
      left: "50%",
      transform: "translateX(-50%)",
      background: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      padding: "10px 20px",
      borderRadius: "8px",
      zIndex: 10000,
      fontSize: "16px",
      textAlign: "center",
    }}
  >
    <p>{isProcessing ? `📤 Uploading... ${uploadProgress}%` : message}</p>
  </div>
)}
      </div>
    </div>
  );
 
};

export default Dashboard;